module.exports = __webpack_public_path__ + "static/media/fishing.0cffa5c3.png";